import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoSpaceX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 212 48"
    {...props}
  >
    <g clipPath="url(#Logo_SpaceX_svg__a)">
      <path
        fill="#005288"
        d="M49.978 17.599h-17.8l-.635.509v15.828h4.895v-5.975l.444-.445h13.096c3.305 0 4.831-.89 4.831-3.178v-3.624c0-2.225-1.526-3.115-4.831-3.115m0 5.848c0 1.08-.7 1.272-2.289 1.272H36.946l-.508-.445v-3.37l.444-.444H47.69c1.526 0 2.289.19 2.289 1.27zm13.858-2.86 4.26 6.23-.255.572h-9.408l-2.416 2.987h13.985l1.017.572 2.162 2.988h5.657L66.443 17.408zm56.132 10.17v-4.449l.509-.445h9.472v-2.797h-15.003v10.87h22.122V31.14H120.54zM114.946 17.6h22.313v3.051h-22.313zM90.09 20.523h17.99c-.254-2.288-1.716-2.924-5.276-2.924H89.9c-4.069 0-5.34.763-5.34 3.878v8.645C84.56 33.173 85.83 34 89.9 34h12.904c3.624 0 5.022-.7 5.149-3.052H90.09l-.508-.508v-9.536zm-70.626 3.433H6.433l-.382-.445v-2.797l.382-.318H24.04l.255-.572c-.572-1.526-2.162-2.289-5.022-2.289H7.004c-4.068 0-5.34.763-5.34 3.878v1.844c0 3.051 1.272 3.877 5.34 3.877h13.033l.38.382v2.924l-.317.445H1.283s-.444.254-.444.318c.317 2.161 1.78 2.733 5.276 2.733h13.35c4.068 0 5.403-.763 5.403-3.877v-2.225c0-3.052-1.335-3.878-5.404-3.878m131.844-6.42h-7.374l-.382.762 8.137 5.976c1.526-.89 3.242-1.78 5.022-2.67zm6.611 11.188 7.183 5.212h7.375l.317-.7-10.679-7.818c-1.399 1.08-2.861 2.161-4.196 3.306"
      />
      <path
        fill="#A7A9AC"
        d="M150.227 33.936h-6.674l-.573-.89C147.494 28.66 167.709 9.971 211.636 8c0 0-36.807 1.271-61.409 25.936"
      />
    </g>
    <defs>
      <clipPath id="Logo_SpaceX_svg__a">
        <path
          fill="#fff"
          d="M.615 0h211v48h-211z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoSpaceX;
